import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import React from 'react';

import {
  extractWizProperty,
  formatWizTimestamp,
} from '@/sections/poe/processors/wiz/helpers';
import type {
  WizParsedData,
  WizRenderContext,
} from '@/sections/poe/processors/wiz/types';

export function renderSecretData(
  parsed: WizParsedData,
  ctx: WizRenderContext
): void {
  const { wizData } = parsed;
  const { sections, tempTabs, mainTabKeys } = ctx;

  if (wizData && wizData['secret data'] && mainTabKeys.includes('DETECTION')) {
    const secretData = wizData['secret data'];
    sections['wiz_secret_data'] = (
      <div className="space-y-4">
        <div className="border-error border-l-4 p-4">
          <div className="flex items-center">
            <ShieldExclamationIcon className="text-error mr-2 size-5" />
            <h4 className="text-chariot-text-primary font-semibold">
              Exposed Secret Data
            </h4>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="border-chariot-stroke rounded-lg border p-4">
            <h5 className="text-chariot-text-primary mb-3 font-medium">
              Certificate Details
            </h5>
            <div className="space-y-2 text-sm">
              {extractWizProperty(secretData, 'name') && (
                <div>
                  <strong>Certificate:</strong>{' '}
                  {extractWizProperty(secretData, 'name')}
                </div>
              )}
              {extractWizProperty(secretData, 'type') && (
                <div>
                  <strong>Type:</strong>{' '}
                  <span className="text-chariot-text-secondary font-mono">
                    {extractWizProperty(secretData, 'type')?.replace(
                      'SecretType',
                      ''
                    )}
                  </span>
                </div>
              )}
              {extractWizProperty(secretData, 'certificate_expiration') && (
                <div>
                  <strong>Expires:</strong>{' '}
                  <span className="text-warning font-medium">
                    {formatWizTimestamp(
                      extractWizProperty(secretData, 'certificate_expiration')
                    )}
                  </span>
                </div>
              )}
              {extractWizProperty(secretData, 'certificate_subjects') && (
                <div>
                  <strong>Subjects:</strong>{' '}
                  <span className="font-mono text-xs">
                    {extractWizProperty(secretData, 'certificate_subjects')}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="border-chariot-stroke rounded-lg border p-4">
            <h5 className="text-chariot-text-primary mb-3 font-medium">
              Security Properties
            </h5>
            <div className="space-y-2 text-sm">
              {extractWizProperty(secretData, 'certificate_issuer') && (
                <div>
                  <strong>Issuer:</strong>{' '}
                  {extractWizProperty(secretData, 'certificate_issuer')}
                </div>
              )}
              {extractWizProperty(secretData, 'certificate_thumbprint') && (
                <div>
                  <strong>Thumbprint:</strong>{' '}
                  <code className="bg-chariot-background-secondary rounded px-1 text-xs break-all">
                    {extractWizProperty(secretData, 'certificate_thumbprint')}
                  </code>
                </div>
              )}
              {extractWizProperty(secretData, 'sha256') && (
                <div>
                  <strong>SHA256:</strong>{' '}
                  <code className="bg-chariot-background-secondary rounded px-1 text-xs break-all">
                    {extractWizProperty(secretData, 'sha256')}
                  </code>
                </div>
              )}
              {extractWizProperty(secretData, 'validationStatus') && (
                <div>
                  <strong>Validation:</strong>{' '}
                  <span className="text-warning">
                    {extractWizProperty(
                      secretData,
                      'validationStatus'
                    )?.replace('SecretsValidationStatus', '')}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
    tempTabs['DETECTION'].push({
      label: 'Secret Data',
      value: 'wiz_secret_data',
    });
  }
}
